/**
 * Hook `useFeatures` — accede al catálogo de features del tenant actual
 * para renderizar UI condicional. Mirror del desktop
 * (`apps/desktop/src/renderer/src/lib/features.ts`).
 *
 * Defensa en profundidad: esto SOLO controla la UI. El worker valida
 * con `assertFeature()` que las mutaciones tengan el feature activo —
 * un cliente rebelde no puede saltárselo.
 */

import { isFeatureEnabled, type FeatureId } from '@atreus/core';

import { trpc } from './trpc.js';

export interface UseFeaturesResult {
  /** `true` si la feature está habilitada. Core features siempre `true`. */
  isEnabled: (id: FeatureId) => boolean;
  /** `false` mientras la query está pendiente — evita flicker. */
  isLoaded: boolean;
}

export const useFeatures = (): UseFeaturesResult => {
  const tenant = trpc.tenant.current.useQuery(undefined, {
    staleTime: 60_000,
  });
  const rows = tenant.data?.features ?? [];
  return {
    isEnabled: (id) => isFeatureEnabled(id, rows),
    isLoaded: !tenant.isLoading,
  };
};
